import { render, staticRenderFns } from "./SharedVideos.vue?vue&type=template&id=24ea31c4&"
import script from "./SharedVideos.vue?vue&type=script&lang=js&"
export * from "./SharedVideos.vue?vue&type=script&lang=js&"
import style0 from "./SharedVideos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports